<template>
  <div id="more-topic" class="userPrivacy__more more-topic">
    <div
      v-if="vm.isMobile && lang !== 'zh'"
      class="more-topic__title wow textInPartMotion"
      data-wow-duration=".7s"
      data-wow-delay=".3s"
      :data-wow-offset="100"
    >
      <img
        v-lazy="require('../../assets/privacy/more-mobile-oversea-title.png')"
        alt="ColorOS 11"
        class="more-mobile-oversea-title-img"
      />
    </div>
    <div
      v-if="!vm.isMobile && lang !== 'zh'"
      class="more-topic__title wow textInPartMotion"
      data-wow-duration=".7s"
      data-wow-delay=".3s"
      :data-wow-offset="100"
    >
      <p>{{ $t('more-topic-title-1') }}</p>
      <p>{{ $t('more-topic-title-2') }}</p>
    </div>
    <div
      v-if="lang == 'zh'"
      class="more-topic__title more-topic__title-zh wow textInPartMotion"
      data-wow-duration=".7s"
      data-wow-delay=".3s"
      :data-wow-offset="100"
    >
      <span>更多</span>
      <span class="green-title">新本事</span>
      <p>ColorOS 11</p>
      <p>更多新本事</p>
    </div>

    <div v-if="!vm.isMobile" class="more-topic-swiper">
      <div class="more-topic-swiper__left" @click="swipeToPrev"></div>
      <swiper
        v-if="$t('more-topic-text-title-1') !== 'more-topic-text-title-1' && moreEnter"
        ref="mySwiper"
        :options="swiperOptions"
        class="more-topic-swiper__main"
        @transitionEnd="swiperTransitionEnd"
      >
        <swiper-slide v-for="(item, index) in moreList" :key="index">
          <section class="more-topic__item">
            <div class="more-topic__item-mask"></div>
            <video v-if="!!item.videoSrc" muted="muted" preload="metadata" loop="true" class="swiper-lazy">
              <source :src="moreList[index].videoSrc" type="video/mp4" />
            </video>
            <img v-else :data-src="item.pcImg" alt="ColorOS 11" class="swiper-lazy" />
            <div
              v-if="index === 0 && lang === 'zh'"
              class="more-topic-text-intro"
              :class="{
                'more-topic-text-intro-multi': lang === 'zh',
                'more-topic-text-intro-game': lang === 'zh' && index === 0
              }"
            >
              <div class="more-topic-game-title">
                <p class="more-topic-text-title">{{ $t('more-topic-text-title-1') }}</p>
                <p class="more-topic-text-sub-title">
                  {{ $t('more-topic-text-sub-title-1') }}
                  <sup>4</sup>
                </p>
              </div>
              <div class="more-topic-game-title">
                <p class="more-topic-text-title">{{ $t('more-topic-text-title-2') }}</p>
                <p class="more-topic-text-sub-title">{{ $t('more-topic-text-sub-title-2') }}</p>
              </div>
              <div class="more-topic-game-title">
                <p class="more-topic-text-title">{{ $t('more-topic-text-title-3') }}</p>
                <p class="more-topic-text-sub-title">{{ $t('more-topic-text-sub-title-3') }}</p>
              </div>
            </div>

            <div v-else class="more-topic-text-intro" :class="lang === 'zh' ? 'more-topic-text-intro-multi' : ''">
              <p class="more-topic-text-title">{{ $t(`more-topic-text-title-${index + (lang === 'zh' ? 3 : 1)}`) }}</p>
              <p class="more-topic-text-sub-title">
                {{ $t(`more-topic-text-sub-title-${index + (lang === 'zh' ? 3 : 1)}`) }}
                <sup v-if="lang === 'zh' && index === 3">5</sup>
              </p>
            </div>
          </section>
        </swiper-slide>
      </swiper>
      <div class="more-topic-swiper__right" @click="swipeToNext"></div>
    </div>
    <ul v-else class="more-topic-list-mobile">
      <li
        v-for="(item, index) in moreList"
        :key="index"
        class="more-topic__item wow textInPartMotion"
        data-wow-duration=".7s"
        data-wow-delay=".3s"
        :data-wow-offset="100"
      >
        <div class="more-topic__item-mask"></div>
        <svg
          v-if="!!item.videoSrc"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="handleVideoMobilePlay(index)"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM22.2 30.5818L30.6 25.732C31.9333 24.9622 31.9333 23.0378 30.6 22.2679L22.2 17.4182C20.8667 16.6484 19.2 17.6107 19.2 19.1503V28.8497C19.2 30.3893 20.8667 31.3516 22.2 30.5818Z"
            fill="currentColor"
          />
        </svg>
        <img v-lazy="item.mobileImg" alt="ColorOS 11" />
        <div v-if="index === 0 && lang === 'zh'" class="more-topic-text-intro">
          <p class="more-topic-text-title">{{ $t('more-topic-text-title-1') }}</p>
          <p class="more-topic-text-sub-title">
            {{ $t('more-topic-text-sub-title-1') }}
            <sup>4</sup>
          </p>
          <p class="more-topic-text-title more-topic-text-multi-title">{{ $t('more-topic-text-title-2') }}</p>
          <p class="more-topic-text-sub-title">{{ $t('more-topic-text-sub-title-2') }}</p>
          <p class="more-topic-text-title more-topic-text-multi-title">{{ $t('more-topic-text-title-3') }}</p>
          <p class="more-topic-text-sub-title">{{ $t('more-topic-text-sub-title-3') }}</p>
        </div>
        <div v-else class="more-topic-text-intro">
          <p class="more-topic-text-title">{{ $t(`more-topic-text-title-${index + (lang === 'zh' ? 3 : 1)}`) }}</p>
          <p class="more-topic-text-sub-title">
            {{ $t(`more-topic-text-sub-title-${index + (lang === 'zh' ? 3 : 1)}`) }}
            <sup v-if="lang === 'zh' && index === 3">5</sup>
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
export default {
  inject: ['vm', 'lang'],
  data() {
    let moreList = [];
    const isMobile = this.vm.isMobile;
    if (this.lang === 'zh') {
      moreList = [
        {
          mobileImg: require('../../assets/zh/privacy/more-topic-1-mobile.jpg'),
          pcImg: require('../../assets/zh/privacy/more-topic-1.jpg')
        },
        {
          mobileImg: require('../../assets/privacy/more-topic-2-mobile.jpg'),
          videoSrc: require('../../assets/privacy/more-topic-2.mp4')
        },
        {
          mobileImg: require('../../assets/zh/privacy/more-topic-3-mobile.jpg'),
          videoSrc: require(`../../assets/zh/privacy/more-topic-3${isMobile ? '-mobile' : ''}.mp4`)
        },
        {
          mobileImg: require('../../assets/zh/privacy/more-topic-4-mobile.jpg'),
          pcImg: require('../../assets/zh/privacy/more-topic-4.jpg')
        },
        {
          mobileImg: require('../../assets/zh/privacy/more-topic-5-mobile.jpg'),
          pcImg: require('../../assets/zh/privacy/more-topic-5.jpg')
        }
      ];
    } else {
      moreList = [
        {
          mobileImg: require('../../assets/privacy/more-topic-1.jpg'),
          videoSrc: require(`../../assets/privacy/more-topic-1${isMobile ? '-mobile' : ''}.mp4`)
        },
        {
          mobileImg: require('../../assets/privacy/more-topic-2-mobile.jpg'),
          videoSrc: require('../../assets/privacy/more-topic-2.mp4')
        }
      ];
    }
    return {
      moreList,
      swiperOptions: {
        loop: true,
        loopedSlides: 4,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: this.lang === 'zh' ? 2 : 1
        }
      },
      moreEnter: false
    };
  },
  mounted() {
    this.scene = new ScrollMagic.Scene({
      triggerElement: '.more-topic',
      offset: -5 * window.innerHeight,
      duration: 7 * window.innerHeight
    })
      .addTo(Controller)
      .on('enter', () => {
        this.moreEnter = true;
        this.playPC();
        this.scene.destroy(true);
      });
  },
  methods: {
    swipeToNext() {
      this.$refs.mySwiper.swiper.slideNext();
      this.playPC();
    },
    swipeToPrev() {
      this.$refs.mySwiper.swiper.slidePrev();
      this.playPC();
    },
    playPC() {
      setTimeout(() => {
        if (this.$refs.mySwiper) {
          const swiper = this.$refs.mySwiper.swiper;
          if (swiper.slides[swiper.activeIndex].querySelector('video'))
            swiper.slides[swiper.activeIndex].querySelector('video').play();
          if (swiper.slides[swiper.previousIndex].querySelector('video'))
            swiper.slides[swiper.previousIndex].querySelector('video').pause();
        }
      }, 100);
    },
    handleVideoMobilePlay(index) {
      console.log('handleVideoMobilePlay');
      this.vm.fullScreenVideo.open({
        src: this.moreList[index].videoSrc
        // poster: this.moreList[index].poster
      });
    },
    swiperTransitionEnd() {
      this.playPC();
    }
  }
};
</script>
<style lang="scss">
.more-topic {
  position: relative;
  z-index: 1;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
}
.more-topic__title {
  display: inline-block;
  padding-top: 156px;
  padding-bottom: 80px;
  font-variation-settings: 'wght' 1000;
  p {
    font-size: 48px;
    line-height: 125%;
  }
  span {
    display: none;
  }
  .green-title {
    padding-left: 10px;
    color: #35d850;
  }
}
html[lang|='zh'] {
  .more-topic__title {
    max-width: none;
  }
}
.more-mobile-oversea-title-img {
  width: 100%;
  max-width: 335px;
}
.more-topic-swiper {
  display: flex;
  padding-bottom: 166px;
  align-items: center;
  /* width: 72.57vw; */
  min-height: 31.1vw;
  max-width: 1205px;
}
.more-topic-swiper__main {
  // ie 11 对 flex: 1 也就是flex: 1 1 0%，其中的 flex-basis: 0%; 理解为width 0
  /* 所以需要改成  flex: 1 1 auto; */
  /* flex: 1;  */
  flex: auto;
  width: 72.57vw;
  height: 31.1vw;
  max-width: 1045px;
  max-height: 448px;
  border-radius: 36px;
  .more-topic__item {
    height: 100%;
  }
}
.more-topic-swiper__left,
.more-topic-swiper__right {
  position: relative;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #f0f0f0;
  cursor: pointer;
  &::before {
    content: ' ';
    position: absolute;
    left: 0;
    top: 0;
    right: -5px;
    bottom: 0;
    margin: auto;
    width: 11px;
    height: 11px;
    opacity: 0.2;
    border: 4px solid #000000;
    border-right: none;
    border-top: none;
    transform: rotate(45deg);
  }
}
.more-topic-swiper__left {
  margin-right: 27px;
}
.more-topic-swiper__right {
  margin-left: 27px;
  &::before {
    right: 5px;
    transform: rotate(-135deg);
  }
}

.more-topic__item {
  position: relative;
  width: 100%;
  font-size: 0;
  overflow: hidden;
  .more-topic__item-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 22.19%, rgba(0, 0, 0, 0.71) 100%);
  }
  video,
  img {
    width: 100%;
    object-fit: contain;
  }
  svg {
    color: #fff;
    position: absolute;
    top: 20px;
    right: 20px;
  }
}
.more-topic-text-intro {
  position: absolute;
  bottom: 71px;
  left: 74px;
  color: #ffffff;
  text-align: left;
  .more-topic-text-title {
    font-size: 36px;
    line-height: 125%;
  }
  .more-topic-text-sub-title {
    margin-top: 16px;
    font-size: 32px;
    line-height: 125%;
  }
}
.more-topic-text-intro-multi {
  bottom: 49px;
  left: 78px;
  .more-topic-text-title {
    font-variation-settings: 'wght' 900;
    font-size: 26px;
    line-height: 125%;
  }
  .more-topic-text-sub-title {
    margin-top: 12px;
    font-size: 14px;
    line-height: 150%;
  }
}
.more-topic-text-intro-game {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 150px);
}

@media screen and (max-width: 1280px) {
  /* .more-topic-text-intro-game {
    .more-topic-text-title {
      font-size: 3vw;
    }
  } */
}

@media screen and (max-width: 734px) {
  .more-topic {
    padding: 5.09vw 5.09vw 78px;
    text-align: left;
    background: #f0f1f0;
  }
  .more-topic__title {
    align-self: self-end;
    padding-top: 30px;
    padding-bottom: 40px;
    font-size: 50px;
    line-height: 60px;
    max-width: none;
  }
  .more-topic-list-mobile {
    display: block;
    width: 100%;
    padding-bottom: 0;
  }
  .more-topic__item {
    margin-bottom: 20px;
    width: 100%;
    border-radius: 10px;
    &:last-of-type {
      margin-bottom: 0;
    }
    img {
      width: 100%;
    }
  }
  .more-topic-text-intro {
    left: 20px;
    bottom: 40px;
    padding: 0;
    color: #ffffff;
    .more-topic-text-title {
      font-size: 24px;
      line-height: 30px;
      font-variation-settings: 'wght' 1000;
    }
    .more-topic-text-sub-title {
      margin-top: 8px;
      font-size: 16px;
      line-height: 20px;
      max-width: 250px;
    }
    .more-topic-text-multi-title {
      padding-top: 24px;
    }
  }
  .more-topic__title-zh {
    span {
      display: inline-block;
    }
    p {
      display: none;
    }
  }
}

@media screen and (min-width: 2560px) {
  .more-topic-swiper {
    min-height: 20vw;
  }
}
</style>
